import { ReactNode } from "react";
import { useStoreContext } from "../../contexts/StoreProvider";
import Header from "../Header";
import Footer from "../Footer";
import Loader from "../Loader";
import styles from "./index.module.scss";

const Layout = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const { state: { loading } } = useStoreContext();

  return (
    <>
      <Header withNav={!loading} />
      <main className={styles.container}>
        {loading ? (
          <Loader heading="Loading Page..." className={styles.loader} />
        ) : (
          children
        )}
      </main>
      {!loading && <Footer />}
    </>
  );
};

export default Layout;
